import React, { useEffect, useState } from "react";
import { apiClient } from "../../config/api";
import Loader from "../../common/Loader";
import "../PrathmikVibhag/PrathmikVibhag.css";
import { useNavigate } from "react-router-dom";
import SectionDivider from "../../common/SectionDivider";


const Uchchmadhyamikvibhag = () => {
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get("/standard");
        setFullData(res.data);
      } catch (error) {
        console.error("Error fetching standards data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCardClick = (standard) => {
    const standerId = standard.id;
    const standerindex = standard.standard_index;
    navigate(`/umadhyamik/${standerindex}?standardId=${standerId}`);

  };

  if (loading) return <Loader />;

  const filteredData = fullData.filter((item) => {
    const index = Number(item.standard_index);
    return index >= 11 && index <= 12;
  });

  const colors = ["#4b34fa", "#0C9D26"];

  return (
    <div className="pv-container">

        <SectionDivider title="ઉચ્ચતર માધ્યમિક વિભાગ ના દરેક ધોરણો" />

      <div className="pv-row">
        {filteredData.map((item, index) => (
          <div
            key={item.id}
            className="pv-card-new"
            style={{ "--accent": colors[index % colors.length] }}
            onClick={() => handleCardClick(item)}
          >
            <div className="pv-card-top">
              <div className="pv-circle-outer">
                <div className="pv-circle-new">
                  {item.standard_index}
                </div>
              </div>
            </div>

            <div className="pv-bottom-band">
              {item.standard_title}
            </div>

          </div>
        ))}
      </div>

    </div>
  );
};

export default Uchchmadhyamikvibhag;
